module.exports = __webpack_public_path__ + "media/images/dutyteam-logo-full-8b300532.svg";